import { render } from "./ProcessItemTemplates.vue?vue&type=template&id=4060147b&scoped=true&ts=true"
import script from "./ProcessItemTemplates.vue?vue&type=script&lang=ts"
export * from "./ProcessItemTemplates.vue?vue&type=script&lang=ts"

import "./ProcessItemTemplates.vue?vue&type=style&index=0&id=4060147b&scoped=true&lang=css"

import exportComponent from "/home/vsts/work/1/s/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4060147b"]])

export default __exports__